import classnames from 'classnames/bind'
import Link from 'components/shared/Link'
import { Label, Text, Title } from 'components/typo'
import React from 'react'
import { useTranslate } from 'react-polyglot'
import { SINGLES } from 'services/constants'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const ArticleCardHorizontalContent = ({
  className,
  href,
  user,
  title,
  introText,
  featuredCategory,
  timeToRead,
  seo,
  publishedAt,
}) => {
  const t = useTranslate()
  const formattedTimeToRead = timeToRead
    ? `${t('blog.read_time_short', { value: timeToRead })}`
    : null

  const publishDate = publishedAt
    ? new Intl.DateTimeFormat('en', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }).format(new Date(publishedAt))
    : null

  return (
    <div className={cx(className, css.ArticleCardContent)}>
      <div className={css.content}>
        {featuredCategory && (
          <div className={css.categoryMobile}>
            {featuredCategory.name && featuredCategory.slug && (
              <Link
                className={cx(css.categoryLink, {
                  withTimeToRead: formattedTimeToRead,
                })}
                href={`${SINGLES.blog.url}/categories/${featuredCategory.slug}`}
              >
                <Label className={css.categoryLabel}>
                  {featuredCategory.name}
                </Label>
              </Link>
            )}
            {formattedTimeToRead && (
              <Label className={css.timeToRead}>{formattedTimeToRead}</Label>
            )}
          </div>
        )}
        {title && (
          <Link className={css.titleLink} href={href}>
            <Title className={css.title}>{title}</Title>
          </Link>
        )}

        {featuredCategory && (
          <div className={css.category}>
            {featuredCategory.name && featuredCategory.slug && (
              <Link
                className={cx(css.categoryLink, {
                  withTimeToRead: formattedTimeToRead,
                })}
                href={`${SINGLES.blog.url}/categories/${featuredCategory.slug}`}
              >
                <Label className={css.categoryLabel}>
                  {featuredCategory.name}
                </Label>
              </Link>
            )}
            {formattedTimeToRead && (
              <Label className={css.timeToRead}>{formattedTimeToRead}</Label>
            )}
          </div>
        )}
        {(introText || seo?.metaDescription) && (
          <Text>{introText || seo.metaDescription}</Text>
        )}
        {user && user?.username && user?.slug && (
          <Link className={css.labelWrapper} href={`/user/${user?.slug}`}>
            <Label className={css.label}>
              <span className={css.author}>{user.username}</span>
              <span className={css.publishDate}>
                {publishDate && publishDate}
              </span>
            </Label>
          </Link>
        )}
      </div>
    </div>
  )
}

ArticleCardHorizontalContent.defaultProps = {}

export default ArticleCardHorizontalContent
